"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
exports.expressPropertyDefinition = expressPropertyDefinition;
const property_1 = require("@genesys/property");
const values_1 = require("../values");
// The water side of a fluid coil. Nothing here is filtered on the coil type any more - the coil
// type decides whether this module is loaded at all.
/** How the fluid side is given: 0 = by outlet temperature, 1 = by flow. */
const byOutletTemperature = "temperatureflow=0";
const byFlow = "temperatureflow=1";
/** A plain water coil (antifreeze 0) has no concentration to state. */
const hasAntifreeze = "antifreeze!=0";
function propertyDefinition() {
    return [
        {
            sort_no: 20,
            name: "temperaturein",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 30,
            name: "temperatureflow",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: (0, values_1.integerValues)(2)
        },
        {
            sort_no: 40,
            name: "temperatureout",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(byOutletTemperature),
            value: []
        },
        {
            sort_no: 50,
            name: "flow",
            group: "",
            quantity: "VolumeFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(byFlow),
            value: []
        },
        ...composition()
    ];
}
function expressPropertyDefinition() {
    return [
        {
            sort_no: 20,
            name: "temperaturein",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 30,
            name: "temperatureflow",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: (0, values_1.integerValues)(2)
        },
        ...sweep("temperatureout", 40, "Temperature", byOutletTemperature),
        ...sweep("flow", 50, "VolumeFlow", byFlow),
        ...composition()
    ];
}
/** The fluid itself, shared by both modes. */
function composition() {
    return [
        {
            sort_no: 60,
            name: "antifreeze",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            // Every fluid CoilPro can calculate, water included.
            value: (0, values_1.integerValues)(9)
        },
        {
            sort_no: 61,
            name: "concentrationtype",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(hasAntifreeze),
            // Decides whether the concentration beside it is by volume or by mass.
            value: (0, values_1.integerValues)(2)
        },
        {
            sort_no: 62,
            name: "concentration",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(hasAntifreeze),
            value: []
        }
    ];
}
/** The min/max/step triple an express run walks. */
function sweep(name, sortNo, quantity, visibleWhen) {
    return ["min", "max", "step"].map((suffix, i) => ({
        sort_no: sortNo + i,
        name: `${name}${suffix}`,
        group: "",
        quantity,
        validation_filter: property_1.PropertyFilter.Empty,
        visibility_filter: (0, values_1.filter)(visibleWhen),
        value: []
    }));
}
//# sourceMappingURL=input-definition.js.map